import myAccountButton from './MyAccountButtonWrapper';
import initWorkflow from './workflow';

var renderers = [myAccountButton];

export { renderers, initWorkflow };